module.exports = __webpack_public_path__ + "static/media/swimClass.02a8185c.svg";